/*
 * @Author: zhengxiaowen
 * @Date: 2018-09-21 09:22:09
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2019-02-26 15:09:34
 */
export default {
  state: {
    certificate: localStorage.userInfo ? JSON.parse(localStorage.getItem('userInfo')).certificate : {},
    userInfo: localStorage.userInfo ? JSON.parse(localStorage.getItem('userInfo')) : {},
    // phoneInfo:{},
    deviceInfo: {},
    webviewKey: null,
    menus: localStorage.menus ? JSON.parse(localStorage.getItem('menus')) : {},
    responsibilityId: localStorage.responsibilityId ? JSON.parse(localStorage.getItem('responsibilityId')).id : -1,
    languageCode: localStorage.languageCode ? JSON.parse(localStorage.getItem('languageCode')).code : '',
    dicCodes: localStorage.getItem('lookupValues') ? JSON.parse(localStorage.getItem('lookupValues')) : {}
  },
  getters: {
  },
  mutations: {
    SET_CERTIFICATE (state, data) {
      state.certificate = data
    },
    // SET_MENU (state, data) {
    //   state.menus = data
    // },
    CONCAT_MENU(state, data){
      state.menus = state.menus.concat(data)
    },

    ADD_MENU(state, item){
      state.menus[item.key] = item.value
      localStorage.setItem('menus',JSON.stringify(state.menus))
    },

    SET_RESPONSIBILITY(state,id){
      const oldid = {id}
      localStorage.setItem('responsibilityId',JSON.stringify(oldid))
      state.responsibilityId = id
    },
    SET_LANGUAGE(state,code){
      const oldcode = {code}
      localStorage.setItem('languageCode',JSON.stringify(oldcode))
      state.languageCode = code
    },
    SET_DIC_CODES(state, data){
      state.dicCodes = data
      try {
        localStorage.setItem('lookupValues', JSON.stringify(data))
        state.dicCodes = localStorage.getItem('lookupValues') ? JSON.parse(localStorage.lookupValues) : {}
        //if (state.dicCodes === {}) {}
      } catch (error) {
        localStorage.removeItem('lookupValues')
      }
    },

    INIT_USER_INFO (state) {
      try {
        state.userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
        console.log(state.userInfo.certificate);
        state.certificate = state.userInfo.certificate
      } catch (error) {
        localStorage.removeItem('userInfo')
      }
    },
    LOGOUT (state) {
      try {
        state.userInfo = null
        state.certificate = null
        state.menus = {}
        state.responsibilityId = -1,
        state.languageCode = ""

      } catch (error) {
        localStorage.removeItem('userInfo')
      }
    },
    INIT_DEVICE_INFO (state) {
      try {
        state.deviceInfo = localStorage.deviceInfo ? JSON.parse(localStorage.deviceInfo) : {}
      } catch (error) {
        localStorage.removeItem('deviceInfo')
      }
    },
    INIT_WEBVIEW_KEY (state) {
      try {
        state.webviewKey = localStorage.webviewKey?localStorage.webviewKey:''
      } catch (error) {
        localStorage.removeItem('webviewKey')
      }
    },



  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/common/store/UserStore.js